var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SettingsMediaUploadVideo',{attrs:{"prop":"video","section":"images","label":_vm.$t('_web_tournament_promo-video-label', 'Promo video:'),"tooltip":_vm.$$t(
      'Promo video will be shown to all users  when they open a tournament profile for a first time.',
      'promo-video-tooltip'
    ),"width":16,"height":9,"recommended-width":1920,"recommended-height":1080,"formats":_vm.acceptedVideo}})}
var staticRenderFns = []

export { render, staticRenderFns }